import { Form, Input, Typography } from "antd";
const { Text } = Typography;

const CustomTextArea = ({
  label,
  name,
  rules,
  inputProps = {},
  formItemProps = {},
  showCharCount = false,
}) => {
  const labelContent = (
    <>
      <Text>{label}</Text>
      <Text style={{ color: "#940808" }}>*</Text>
    </>
  );

  return (
    <Form.Item
      label={labelContent}
      name={name}
      rules={rules}
      required={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      {...formItemProps}
    >
      <Input.TextArea
        rows={6}
        size="large"
        style={{
          fontSize: 14,
        }}
        showCount={showCharCount} // Menampilkan jumlah karakter otomatis
        {...inputProps}
      />
    </Form.Item>
  );
};

export default CustomTextArea;
